import { Authenticator } from '@aws-amplify/ui-react';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import store from '@/redux/store';
import { ToastProvider } from './providers/toast-provider';
import { router } from './router/router';

export const App: FC = () => (
  <div className="font-inter fixed top-0 right-0 bottom-0 left-0 overflow-hidden bg-slate-100 p-0">
    <Provider store={store}>
      <Authenticator.Provider>
        <ToastProvider>
          <RouterProvider router={router}></RouterProvider>
        </ToastProvider>
      </Authenticator.Provider>
    </Provider>
  </div>
);
